import React from "react";
import ProductGallery from "../../GalleryImagesComponent";
import Image1 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS1.webp";
import Image2 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS2.webp";
import Image3 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS3.webp";
import Image4 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS4.webp";
import Image5 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS5.webp";
import Image6 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS6.webp";
import Image7 from "../../../../Product/Casual/Hoody_Sweatshirt/HSS7.webp";

const HoodySweatShirt = () => {
  const images = [Image1, Image2, Image3, Image4, Image5, Image6, Image7];

  return (
    <ProductGallery
      images={images}
      category={{ english: "casual", enName: "Casual", arabic: "كاجوال", arName: "كاجوال" }}
      product={{ english: "Hoody Sweat Shirt", arabic: "هودى" }}
    />
  );
};

export default HoodySweatShirt;
